var map = {
	"./ConcernView": [
		52633,
		2633
	],
	"./ConcernView.tsx": [
		52633,
		2633
	],
	"./OperationView": [
		68691,
		8691
	],
	"./OperationView.tsx": [
		68691,
		8691
	],
	"./PaymentView": [
		27164,
		7164
	],
	"./PaymentView.tsx": [
		27164,
		7164
	],
	"./PolicyView": [
		25709,
		5709
	],
	"./PolicyView.tsx": [
		25709,
		5709
	],
	"./RefundView": [
		69501,
		9501
	],
	"./RefundView.tsx": [
		69501,
		9501
	],
	"./SecurityView": [
		83178,
		3178
	],
	"./SecurityView.tsx": [
		83178,
		3178
	],
	"./ShippingDeliveryView": [
		35077,
		5077
	],
	"./ShippingDeliveryView.tsx": [
		35077,
		5077
	],
	"./en-US/marketing/v0": [
		76156,
		6156
	],
	"./en-US/marketing/v0.tsx": [
		76156,
		6156
	],
	"./en-US/marketing/v1": [
		5836,
		5836
	],
	"./en-US/marketing/v1.tsx": [
		5836,
		5836
	],
	"./en-US/term/v0": [
		63107,
		3107
	],
	"./en-US/term/v0.tsx": [
		63107,
		3107
	],
	"./en-US/term/v1": [
		6624,
		6624
	],
	"./en-US/term/v1.tsx": [
		6624,
		6624
	],
	"./km-KH/TermsAndConditions": [
		1356,
		1356
	],
	"./km-KH/TermsAndConditions.tsx": [
		1356,
		1356
	],
	"./vi-VN/CommitOrder": [
		47935,
		7935
	],
	"./vi-VN/CommitOrder.tsx": [
		47935,
		7935
	],
	"./vi-VN/TermsAndConditions": [
		23737,
		3737
	],
	"./vi-VN/TermsAndConditions.tsx": [
		23737,
		3737
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 84688;
module.exports = webpackAsyncContext;